import type { SyncHasMany } from "@ember-data/model";
import Model, { hasMany } from "@ember-data/model";
import type ModelRegistry from "@ember-data/types/registries/model";

export default class DefaultBioExamModel extends Model {
  @hasMany("therapeutical-area", { async: false, inverse: "defaultBioExams" })
  declare therapeuticalAreas: SyncHasMany<ModelRegistry["therapeutical-area"]>;

  get bioExamObservation() {
    return this.store.peekRecord("loinc", this.id);
  }
}

declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "default-bio-exam": DefaultBioExamModel;
  }
}
